<template>
  <div class="statistics-pane">
    <div class="statistics-pane-header">
      <div class="statistics-pane-title single-ellipsis">
        <span>{{ unitGroup.name }}标签列表</span>
        <el-tooltip effect="dark" content="系统尚未关联的标签为待确认标签，不纳入图表统计数据。" placement="top">
          <i class="el-icon-warning"></i>
        </el-tooltip>
      </div>
      <el-button type="text" @click="$emit('showFieldsEditor')">
        <span>全部</span>
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>

    <div class="statistics-pane-tools">
      <div class="statistics-pane-tool-item primary-item">
        <el-dropdown @command="action => toolHandle({ commandKey: action })">
          <div>
            <i class="iconfont iconjia"></i>
            <span>新建</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="createField">
              <span>创建新标签</span>
            </el-dropdown-item>
            <el-dropdown-item command="importOwner">
              <span>引用其他课题标签</span>
            </el-dropdown-item>
            <el-dropdown-item command="importSystem" v-if="sysDataWays.includes(courseDetail._source.instrumentType)">
              <span>引用系统预置标签</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="statistics-pane-tool-item">
        <el-popover
          ref="statisticsFieldListRef"
          placement="bottom-end"
          width="240"
          trigger="click"
          @show="statisticsFieldListEditShow = true"
          @hide="statisticsFieldListEditShow = false"
        >
          <statisticsFieldListEditor
            v-if="statisticsFieldListEditShow"
            :fields="fields"
            :hideAndSortInfo="curHideAndSortInfo"
            @updFieldsHideAndSort="updFieldsHideAndSort"
            @close="$refs.statisticsFieldListRef.doClose()"
          />
          <div slot="reference">
            <i class="iconfont iconxianshigaoliang"></i>
            <span>标签显示及排序</span>
          </div>
        </el-popover>
      </div>
    </div>

    <div class="statistics-pane-filter">
      <el-input v-model="filterKeyword" placeholder="请输入搜索内容" prefix-icon="el-icon-search" />
    </div>

    <div class="statistics-pane-tabs">
      <div class="statistics-pane-tab-item" :class="tabActive === 'show' && 'is-active'" @click="tabActive = 'show'">
        <span>全部</span>
        <span class="statistics-pane-tab-item-num">{{ fieldCount.show }}</span>
      </div>
      <div
        class="statistics-pane-tab-item"
        :class="tabActive === 'relation' && 'is-active'"
        @click="tabActive = 'relation'"
      >
        <span>关联</span>
        <span class="statistics-pane-tab-item-num">{{ fieldCount.relation }}</span>
      </div>
      <div class="statistics-pane-tab-item" :class="tabActive === 'hide' && 'is-active'" @click="tabActive = 'hide'">
        <span>隐藏</span>
        <span class="statistics-pane-tab-item-num">{{ fieldCount.hide }}</span>
      </div>
    </div>

    <div class="field-ul-empty-tip" v-if="formatFields.length < 1">
      <span>暂无标签</span>
    </div>

    <div class="field-ul" v-loading="refreshStatisticsLoading > 0">
      <div class="field-ul-container">
        <div
          v-for="(item, index) in formatFields"
          :key="item.columnKey"
          class="field-li"
          :class="fieldFormDataArr[index].taskStatus === 'error' ? 'is-error' : ''"
          :name="item.columnKey"
          v-show="filterKeyword ? item.title.includes(filterKeyword) : true"
        >
          <div class="field-sort-num">
            <div class="theme-tag-content" :class="fieldFormDataArr[index].fieldThemeName">{{ index + 1 }}</div>
          </div>
          <div class="field-header" :class="tabActive === 'hide' && 'hide-mode-header'">
            <div class="title theme-title single-ellipsis" :class="fieldFormDataArr[index].fieldThemeName">
              <span>{{ item.title }}</span>
            </div>
            <div class="update-user-info" v-if="item.updateUser && item.updateUser.headimgurl">
              <img :src="item.updateUser.headimgurl" />
            </div>
            <div class="tool-icon" v-if="tabActive !== 'hide'">
              <i class="iconfont iconbianji icon-btn" @click.stop="toolHandle({ commandKey: 'editField', item })"></i>
              <el-dropdown @command="commandKey => toolHandle({ commandKey, item, index })">
                <i class="iconfont icongengduo icon-btn"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="showHistory" v-if="fieldFormDataArr[index].historyList.length > 0">
                    <i class="iconfont iconlishi word-normal"></i>
                    <span>标注记录</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="removeField">
                    <i class="iconfont iconcha word-normal"></i>
                    <span>移除</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="delField" v-if="item._id === item.field_name">
                    <i class="iconfont iconshanchu word-normal"></i>
                    <span>删除</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="tool-icon" v-else v-show="!hideAutoTagTools">
              <el-button
                type="primary"
                class="field-content-btn"
                :loading="fieldFormDataArr[index].updHideLoading"
                @click="updFieldHideHandle(item, index)"
              >
                <span>恢复显示</span>
              </el-button>
            </div>
          </div>
          <template v-if="tabActive !== 'hide'">
            <div class="field-task-content" v-if="statisticsStatus.pending.includes(item.columnKey)">
              <div class="progress-content">
                <el-progress
                  :style="{ margin: '7px 0' }"
                  :percentage="
                    Math.floor((fieldFormDataArr[index].now_size / (fieldFormDataArr[index].taskTotal || 1)) * 100)
                  "
                  :color="fieldFormDataArr[index].taskStatus | formatStatusHandle"
                  :show-text="false"
                />
                <!-- <div class="progress-tips">
                  <span>正在标注中...</span>
                </div> -->
                <div class="progress-tips">
                  <span>{{ fieldFormDataArr[index].now_size }} / </span>
                  <span>{{ fieldFormDataArr[index].taskTotal }}</span>
                  <span :style="{ marginLeft: '8px' }"
                    >({{
                      Math.floor((fieldFormDataArr[index].now_size / (fieldFormDataArr[index].taskTotal || 1)) * 100)
                    }})%</span
                  >
                </div>
              </div>
              <div class="tool-btn">
                <el-button
                  :style="{ padding: 0 }"
                  type="text"
                  v-if="['running', 'pending'].includes(fieldFormDataArr[index].taskStatus)"
                  @click="cancelTaskHandle(fieldFormDataArr[index].taskId)"
                >
                  <span>取消</span>
                </el-button>
              </div>
            </div>
            <template v-else>
              <div class="error-tip" v-if="fieldFormDataArr[index].taskErrMsg">
                <i class="el-icon-warning error-icon"></i>
                <span>{{ fieldFormDataArr[index].taskErrMsg }}</span>
              </div>
              <div
                class="field-content"
                @mouseenter="fieldHover[item.columnKey].itemHover = true"
                @mouseleave="fieldHover[item.columnKey].itemHover = false"
              >
                <div class="label-info" v-if="fieldFormDataArr[index].statistics">
                  <div class="label-info-item">
                    <span class="info-tip could-tap" @click="fieldFilterHandle('label', item)">已标注案件数：</span>
                    <span>{{ (fieldFormDataArr[index].statistics.total || 0).toLocaleString() }}</span>
                  </div>
                  <div class="label-info-item">
                    <span class="info-tip could-tap" @click="fieldFilterHandle('noneLabel', item)">未标注案件数：</span>
                    <span>{{ (fieldFormDataArr[index].statistics.emptyTotal || 0).toLocaleString() }}</span>
                  </div>
                  <div class="label-info-item single-ellipsis">
                    <span class="recommend-tip">
                      <span>标签属性：</span>
                      <span>{{ item.groupRelationId | unitGorupFilter(unitGroupList) }}</span>
                    </span>
                  </div>
                  <div class="label-info-item" v-if="recommendTaskArr[item.columnKey]">
                    <span class="recommend-tip">正在智能推荐中...</span>
                  </div>
                  <div
                    class="label-info-item is-recommend"
                    @click="
                      () => ($emit('recommend', item), toolHandle({ commandKey: 'editField', item, byRecommend: true }))
                    "
                    v-else-if="fieldFormDataArr[index].statistics.recommend"
                  >
                    <span>智能推荐</span>
                    <span> {{ fieldFormDataArr[index].statistics.recommend.toLocaleString() }} </span>
                    <span>个相似描述，请去标注</span>
                    <i class="iconfont iconzuozhankai-xiantiao"></i>
                  </div>
                </div>
                <el-dropdown
                  class="statistics-field-tools-content"
                  split-button
                  type="primary"
                  szie="mini"
                  @click="handleCommand('autoTag1', item)"
                  v-show="
                    !hideAutoTagTools &&
                      fieldHover[item.columnKey] &&
                      (fieldHover[item.columnKey].itemHover || fieldHover[item.columnKey].popoverHover)
                  "
                >
                  <span>追加标注</span>
                  <el-dropdown-menu slot="dropdown">
                    <div
                      class="custom-dropdown-tools-container"
                      @mouseenter="fieldHover[item.columnKey].popoverHover = true"
                      @mouseleave="fieldHover[item.columnKey].popoverHover = false"
                    >
                      <div class="custom-dropdown-tools-ul">
                        <div class="custom-dropdown-tools-li" @click="handleCommand('autoTag2', item)">
                          <div class="custom-dropdown-tools-li-title">
                            <span>覆盖标注</span>
                          </div>
                          <div class="custom-dropdown-tools-li-desc">
                            <span
                              >以当前全新的规则重新清洗全部案件。（对预置标签进行覆盖操作后，无法恢复初始化，请谨慎操作。）</span
                            >
                          </div>
                        </div>
                        <div class="custom-dropdown-tools-li" @click="handleCommand('autoTag1', item)">
                          <div class="custom-dropdown-tools-li-title">
                            <span>追加标注</span>
                          </div>
                          <div class="custom-dropdown-tools-li-desc">
                            <span
                              >在原来规则的基础上，加上新增规则来清洗未标注的案件。（对预置标签进行追加操作后，无法恢复初始化，请谨慎操作。）</span
                            >
                          </div>
                        </div>
                        <div class="custom-dropdown-tools-li" @click.stop="handleCommand('resetField', item)">
                          <div class="custom-dropdown-tools-li-title">
                            <span>还原标注</span>
                          </div>
                          <div class="custom-dropdown-tools-li-desc">
                            <span
                              >还原之后，已标注的案件全部变为无标注。（对预置标签进行还原操作后，无法恢复初始化，请谨慎操作。）</span
                            >
                          </div>
                        </div>
                        <div
                          class="custom-dropdown-tools-li"
                          @click.stop="handleCommand('refreshRecommend', item)"
                          v-if="(fieldFormDataArr[index].statistics.operation || 0) > 0"
                        >
                          <div class="custom-dropdown-tools-li-title">
                            <span>智能推荐</span>
                          </div>
                          <div class="custom-dropdown-tools-li-desc">
                            <span>根据以往标注内容智能推荐。</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>

    <batch-history-modal
      v-if="historyModal.show"
      :show.sync="historyModal.show"
      :courseId="courseDetail._id"
      :fieldDetail="historyModal.fieldDetail"
      :historyList="historyModal.historyList"
      @success="refreshHandle"
    />

    <auto-tag-picker
      v-if="pickModal.show"
      :show.sync="pickModal.show"
      :type="pickModal.type"
      @success="action => handleCommand(action, pickModal.item)"
    />
  </div>
</template>

<script>
import batchHistoryModal from './batchHistoryModal';
import statisticsFieldListEditor from './statisticsFieldListEditor';
import autoTagPicker from './autoTagPicker';

import sortImg from '@/assets/img/排序@2x.png';
import { services } from '@/service';
import { sysDataWays } from '@/constant';

let msgEl = null;

export default {
  components: { batchHistoryModal, autoTagPicker, statisticsFieldListEditor },
  data() {
    return {
      sortImg,
      fieldFormDataArr: [],
      statisticsStatus: {
        pending: []
      },
      timeoutController: 0,
      historyModal: {
        show: false,
        fieldDetail: null,
        historyList: []
      },
      recommendTaskArr: {},
      pickModal: {
        show: false,
        type: '',
        item: null
      },
      fieldHover: {},
      filterKeyword: '',
      tabActive: 'show',
      updHideShow: false,
      updSortShow: false,
      statisticsFieldListEditShow: false,
      refreshStatisticsLoading: 0
    };
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    courseDetail: {
      type: Object,
      required: true
    },
    researchModel: {
      type: Object,
      default: () => null
    },
    dataSource: {
      type: String,
      default: ''
    },
    fetchQueryBody: {
      type: Function,
      required: true
    },
    currentRecommend: {
      type: Object,
      default: () => null
    },
    hideAutoTagTools: {
      type: Boolean,
      default: false
    },
    unitGroup: {
      type: Object,
      required: true
    },
    unitGroupList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fieldInitInfo: {
      handler() {
        this.changeFieldHandle();
      },
      immediate: true
    }
  },
  filters: {
    formatStatusHandle(status) {
      if (status === 'done') {
        return '#67C23A';
      }
      if (status === 'error' || status === 'cancel') {
        return '#F56C6C';
      }
      return '#409EFF';
    },
    formatStatusText(status) {
      const statusEnum = {
        done: '已完成',
        error: '异常',
        cancel: '已取消',
        running: '进行中',
        pending: '等待中'
      };
      return statusEnum[status] || '-';
    },
    unitGorupFilter(groupId, unitGroupList) {
      const unitGroupItem = unitGroupList.find(o => o.id === groupId);
      return unitGroupItem ? unitGroupItem.name : '-';
    }
  },
  computed: {
    sysDataWays() {
      return sysDataWays;
    },
    allHideAndSort() {
      const { hideAndSort = {} } = this.researchModel || this.courseDetail._source;

      return hideAndSort;
    },
    curHideAndSortInfo() {
      let { hideIds, sortIds } = this.allHideAndSort[this.unitGroup.id] || {};

      // 没有设置隐藏时读取旧的 hideLight 字段作为隐藏依据
      if (!hideIds) {
        hideIds = this.fields.filter(fieldDetail => fieldDetail.hideLight).map(fieldDetail => fieldDetail._id);
      }

      // 没有设置排序时按照fields的顺序排序
      if (!sortIds) {
        sortIds = this.fields.map(fieldDetail => fieldDetail._id);
      }

      return { hideIds, sortIds };
    },
    formatFields() {
      let arr = this.fields;

      if (this.tabActive === 'hide') {
        arr = arr.filter(fieldDetail => this.curHideAndSortInfo.hideIds.includes(fieldDetail._id));
      } else {
        arr = arr.filter(fieldDetail => !this.curHideAndSortInfo.hideIds.includes(fieldDetail._id));
        if (this.tabActive === 'relation') {
          arr = arr.filter(fieldDetail => this.relationFieldIds.includes(fieldDetail._id));
        }
      }

      return arr;
    },
    fieldInitInfo() {
      return { unitGroup: this.unitGroup, formatFields: this.formatFields };
    },
    relationFieldIds() {
      return this.fields
        .filter(fieldDetail => {
          return (
            this.unitGroup.id === fieldDetail.groupRelationId ||
            [...this.unitGroup.nerIds, ...this.unitGroup.labelIds].includes(fieldDetail.field_name)
          );
        })
        .map(o => o._id);
    },
    fieldCount() {
      let show = 0;
      let hide = 0;
      let relation = 0;

      this.fields.forEach(o => {
        if (this.curHideAndSortInfo.hideIds.includes(o._id)) {
          hide++;
        } else {
          show++;
          if (this.relationFieldIds.includes(o._id)) {
            relation++;
          }
        }
      });

      return { show, relation, hide };
    }
  },
  beforeDestroy() {
    this.clearTimeoutController();
  },
  methods: {
    updFieldsHideAndSort({ hideIds, sortIds, callback }) {
      this.$emit('updFieldsHideAndSort', {
        hideAndSort: {
          ...this.allHideAndSort,
          [this.unitGroup.id]: {
            hideIds,
            sortIds
          }
        },
        callback
      });
    },
    updFieldHideHandle(fieldItem, fieldIndex) {
      this.fieldFormDataArr[fieldIndex].updHideLoading = true;
      this.$emit('updFieldsHideAndSort', {
        hideAndSort: {
          ...this.allHideAndSort,
          [this.unitGroup.id]: {
            hideIds: this.curHideAndSortInfo.hideIds.filter(fieldId => fieldId !== fieldItem._id),
            sortIds: this.curHideAndSortInfo.sortIds
          }
        },
        callback: success => {
          this.fieldFormDataArr[fieldIndex].updHideLoading = false;
          success && this.$message.success('恢复成功');
        }
      });
    },
    toolHandle({ commandKey, item, index, byRecommend = false }) {
      if (commandKey === 'showHistory') {
        this.showHistoryHandle(item, index);
      }
      if (commandKey === 'editField') {
        this.$emit('editField', { fieldDetail: item, fieldDefaultInfo: { byRecommend } });
      }
      if (['removeField', 'delField', 'createField'].includes(commandKey)) {
        this.$emit(commandKey, item);
      }
      if (commandKey === 'importOwner' || commandKey === 'importSystem') {
        this.$emit('importField', commandKey);
      }
    },
    refreshHandle() {
      this.refreshStatisticsHandle();
      this.clearTimeoutController();
      this.fetchStatisticsHandle();
    },
    showHistoryHandle(fieldDetail, index) {
      const historyList = this.fieldFormDataArr[index].historyList;
      this.historyModal = { show: true, fieldDetail, historyList };
    },
    handleCommand(action, item) {
      if (action === 'autoTagPick') {
        this.pickModal = { show: true, type: 'autoTag1', item };
      }
      if (['autoTag1', 'autoTag2'].includes(action)) {
        this.autoAddTagHandle(item, action);
      }
      if (action === 'resetField') {
        this.$emit('resetFieldTag', item);
      }
      if (action === 'refreshRecommend') {
        this.refreshRecommendHandle(item);
      }
    },
    async refreshRecommendHandle(item) {
      await services.caseRule.refreshRecommend(item.field_name);
      this.refreshHandle();
    },
    fieldFilterHandle(action, fieldDetail) {
      this.$emit(action, { headerItem: fieldDetail });
    },
    async refreshStatisticsHandle() {
      try {
        this.refreshStatisticsLoading++;

        const queryBody = this.fetchQueryBody();
        if (this.currentRecommend) {
          queryBody.query.push({
            isRecommend: true,
            info: {
              fieldDetail: this.currentRecommend
            }
          });
        }
        queryBody.parentId = this.unitGroup.id;
        const result = await services.caseRule.getTagStatistics(queryBody);
        this.$emit('updRecommendTotal', result);
        this.formatFields.forEach(fieldItem => {
          const currentFieldFormData = this.fieldFormDataArr.find(fieldFormItem => {
            return fieldFormItem.columnKey === fieldItem.columnKey;
          });
          if (currentFieldFormData) {
            currentFieldFormData.statistics = {
              labelId: fieldItem.columnKey,
              total: 0,
              emptyTotal: 0,
              recommend: 0,
              operation: 0,
              ...(result[fieldItem.columnKey] || {})
            };
          }
        });
      } catch (err) {
        throw Error(err);
      } finally {
        this.refreshStatisticsLoading--;
      }
    },
    clearTimeoutController() {
      if (this.timeoutController) {
        clearTimeout(this.timeoutController);
      }
      this.timeoutController = 0;
    },
    async changeFieldHandle() {
      const fieldFormDataArr = [];
      const ruleArrInfo = [];
      const fieldHover = {};
      const fieldColorArrLength = 16;

      this.formatFields.forEach((fieldItem, fieldIndex) => {
        fieldHover[fieldItem.columnKey] = { itemHover: false, popoverHover: false };
        const fieldThemeName = `field-color-${(fieldIndex + 1) % fieldColorArrLength}`;
        const currentFieldFormData = this.fieldFormDataArr.find(fieldFormItem => {
          return fieldFormItem.columnKey === fieldItem.columnKey;
        });
        if (currentFieldFormData) {
          fieldFormDataArr.push({ ...currentFieldFormData, fieldThemeName });
        } else {
          fieldFormDataArr.push({
            _id: fieldItem._id,
            columnKey: fieldItem.columnKey,
            fieldThemeName,
            statistics: { label: 0 },
            now_size: 0,
            taskTotal: 0,
            taskStatus: 'done',
            taskId: '',
            historyList: [],
            updHideLoading: false
          });
        }
        ruleArrInfo.push({ ...fieldItem, fieldThemeName, fieldIndex });
      });
      this.fieldHover = fieldHover;
      this.fieldFormDataArr = fieldFormDataArr;
      this.statisticsStatus = { pending: [] };
      this.refreshStatisticsHandle();
      this.$emit('changeTaskStatus', this.statisticsStatus);
      this.$emit('changeRuleArrInfo', ruleArrInfo);
      this.clearTimeoutController();
      this.fetchStatisticsHandle();
    },
    async fetchStatisticsHandle() {
      try {
        const keys = this.formatFields.map(item => item.columnKey);
        const result = await services.caseRule.getTaskQueueInfo(this.courseDetail._id, keys);
        const pending = [...this.statisticsStatus.pending];

        this.fieldFormDataArr = this.fieldFormDataArr.map(formItem => {
          let taskItem = result.data.find(item => item._source.field_name === formItem.columnKey);
          if (!result.buckets[formItem.columnKey]) {
            result.buckets[formItem.columnKey] = {};
          }
          if (!taskItem) {
            taskItem = result.buckets[formItem.columnKey].current;
          }
          if (taskItem) {
            taskItem = {
              ...taskItem,
              ...(taskItem._source || {})
            };
          }
          if (taskItem) {
            return {
              ...formItem,
              taskStatus: taskItem.status || 'done',
              taskErrMsg: taskItem.message || '',
              taskId: taskItem._id || '',
              now_size: taskItem.percentageNum || 0,
              taskTotal: taskItem.percentageTotal || 0,
              historyList: result.buckets[formItem.columnKey].history || []
            };
          } else {
            return {
              ...formItem,
              taskStatus: 'done',
              now_size: formItem.taskTotal,
              historyList: result.buckets[formItem.columnKey].history || []
            };
          }
        });

        let newPending = result.data
          .map(taskItem => {
            if (['running', 'pending'].includes(taskItem._source.status)) {
              return taskItem._source.field_name;
            }
            return '';
          })
          .filter(fieldName => !!fieldName);

        let needRefreshStatistics =
          String(Object.keys(this.recommendTaskArr)) !== String(Object.keys(result.recommendTaskArr));

        newPending = [...new Set(newPending)];
        if (!needRefreshStatistics) {
          needRefreshStatistics = pending.some(fieldId => {
            return !newPending.includes(fieldId);
          });
        }

        if (needRefreshStatistics) {
          await this.refreshStatisticsHandle();
        }

        this.statisticsStatus = { pending: newPending };
        this.recommendTaskArr = result.recommendTaskArr;
        this.$emit('changeTaskStatus', this.statisticsStatus);
        this.clearTimeoutController();
        if (this.statisticsStatus.pending.length > 0 || Object.keys(this.recommendTaskArr).length > 0) {
          this.timeoutController = setTimeout(() => this.fetchStatisticsHandle(), 2000);
        }
      } catch (err) {
        console.error(err);
        services.logger.handleLog({
          operateName: '实证分析任务接口报错',
          apiUrl: '/nlp/runlabel/task'
        });
      }
    },
    async autoAddTagHandle(item, action) {
      if (msgEl) {
        return;
      }
      msgEl = this.$message({ message: '正在添加自动标注...', duration: 0 });
      try {
        const runType = action === 'autoTag1' ? '追加' : '覆盖';
        await services.caseRule.autuAddTag({
          courseId: this.courseDetail._id,
          courseTitle: this.courseDetail._source.title,
          dataSource: this.dataSource,
          fieldDetailArr: [item],
          runType
        });
        this.fieldHover[item.columnKey].popoverHover = false;
        this.$message.success('自动标注已经加入标注队列');
        this.clearTimeoutController();
        this.fetchStatisticsHandle();
      } catch (err) {
        this.$error(err);
      } finally {
        msgEl.close();
        msgEl = null;
      }
    },
    async cancelTaskHandle(taskId) {
      await this.$confirm(`是否取消该标注任务?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        await services.caseRule.cancelTagTask(taskId);
        this.$message.success('成功取消自动标注任务');
        this.clearTimeoutController();
        this.fetchStatisticsHandle();
      } catch (err) {
        this.$error(err);
      }
    }
  }
};
</script>
<style lang="scss">
.statistics-collapse-fields {
  .el-collapse-item__header {
    cursor: default !important;
  }
  .el-collapse-item__arrow {
    opacity: 0;
  }
}
.statistics-field-tools-content {
  position: absolute !important;
  top: 4px;
  right: 0;
}
</style>
<style lang="scss" scoped>
@import '../index.scss';

.blue-btn {
  color: #1991fb;
  border: 1px solid #1991fb;
  border-color: #1991fb !important;
}
.statistics-pane {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;

  .statistics-pane-header {
    box-sizing: border-box;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #3d465a;
    font-size: 14px;
    padding: 0 10px;

    .statistics-pane-title {
      box-sizing: border-box;
      position: relative;
      width: fit-content;
      max-width: calc(100% - 50px);
      padding-right: 20px;

      & > span {
        font-weight: 500;
      }

      .el-icon-warning {
        position: absolute;
        right: 0;
        top: 0;
        color: #f8bf05;
      }
    }

    .el-icon-arrow-right {
      position: relative;
      top: 1px;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .statistics-pane-filter {
    padding: 0 10px;
  }

  .field-ul-empty-tip {
    font-size: 14px;
    color: #9599a5;
    text-align: center;
    padding: 30px;
  }

  .statistics-pane-tabs {
    display: flex;
    border-bottom: 1px solid #e8ebef;

    .statistics-pane-tab-item {
      position: relative;
      flex: 1;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #3d465a;
      font-size: 14px;
      cursor: pointer;

      & > span {
        font-weight: inherit;
      }

      .statistics-pane-tab-item-num {
        margin-left: 2px;
      }

      &:not(:last-child) {
        &::after {
          content: ' ';
          position: absolute;
          top: 50%;
          right: 0;
          height: 50%;
          width: 1px;
          transform: translateY(-50%);
          background-color: #e8ebef;
        }
      }

      &::before {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        width: 100%;
        background-color: #1991fb;
        visibility: hidden;
      }

      &.is-active {
        color: #1991fb;
        font-weight: bold;
        &::before {
          visibility: visible;
        }
      }
    }
  }

  .statistics-pane-tools {
    display: flex;
    justify-content: space-between;
    padding: 0 10px 10px;

    ::v-deep .statistics-pane-tool-item {
      color: #3d465a;
      font-size: 12px;
      line-height: 18px;
      cursor: pointer;
      text-align: center;
      padding: 0 12px;

      .statistics-pane-tool-item-img {
        position: relative;
        top: 1px;
        width: 14px;
        height: 14px;
      }

      .iconfont {
        font-size: 14px;
        margin-right: 4px;
      }

      &.primary-item {
        color: #1991fb;

        .el-dropdown {
          font-size: 12px;
          color: #1991fb;
        }
      }

      &.is-active {
        .iconfont {
          color: #1991fb;
        }
      }
    }
  }

  .field-ul {
    flex: 1;
    width: 100%;
    height: 0;

    .field-ul-container {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      background-color: #f9fbff;
      padding: 15px 10px;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .field-li {
      position: relative;
      box-sizing: border-box;
      margin-bottom: 10px;
      border: 1px solid #edf1f7;
      background-color: #fff;
      padding: 5px 10px;

      &:last-child {
        margin-bottom: 0;
      }

      .field-sort-num {
        position: absolute;
        top: -7px;
        left: -7px;
        line-height: 18px;
        text-align: center;
        color: #2c3443;
        font-size: 12px;
        background-color: #fff;
        user-select: none;

        .theme-tag-content {
          box-sizing: border-box;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 1px solid #fff;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      .field-header {
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.hide-mode-header {
          height: fit-content;
          min-height: 40px;
          .single-ellipsis {
            white-space: normal;
          }
          .tool-icon {
            display: block;
            opacity: 0;
          }
          .update-user-info {
            position: relative;
            right: -4px;
            margin-right: -20px;
          }
        }

        .title {
          flex: 1;
          width: 0;
          font-size: 14px;
        }

        .update-user-info {
          border-radius: 50%;
          overflow: hidden;
          & > img {
            width: 20px;
            height: 20px;
          }
        }

        .tool-icon {
          display: none;

          .icon-btn {
            font-size: 14px;
            color: #9599a5;
            padding: 2px 1px;
            cursor: pointer;
            margin-left: 5px;

            &.iconxianshigaoliang {
              color: #409eff;
            }
          }
        }
      }
      .error-tip {
        font-size: 12px;
        color: #f62733;
        width: 100%;
        line-height: 20px;
        margin-top: 6px;

        .error-icon {
          margin-right: 4px;
        }
      }
      .field-content {
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 4px;

        ::v-deep .field-btn-tools {
          position: absolute;
          top: 4px;
          right: 0;
          padding: 0;

          & > span {
            display: block;
            height: 28px;
            line-height: 28px;
            padding: 0 10px;

            .field-btn-text {
              position: relative;
              height: 100%;
              padding-right: 5px;
              margin-right: 5px;

              &::after {
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                width: 1px;
                height: 100%;
                background-color: #fff;
              }
            }
          }
        }

        .label-info {
          flex: 1;
          width: 0;
          .label-info-item {
            font-size: 12px;
            color: rgba(#2c3443, 0.7);
            line-height: 20px;
            .recommend-tip {
              color: #9599a5;
            }
            .info-tip {
              color: #9599a5;
              cursor: pointer;

              &.could-tap {
                &:hover {
                  color: #409eff;
                }
              }
            }

            &.is-recommend {
              color: #409eff;
              cursor: pointer;

              .iconfont {
                font-size: 12px;
                margin-left: 2px;
              }
            }
          }
        }
        .tool-btn {
          opacity: 0;
        }

        .field-content-btn {
          opacity: 0;
        }
      }

      .field-task-content {
        display: flex;
        align-items: flex-start;

        .progress-content {
          flex: 1;
          width: 0;

          .progress-tips {
            font-size: 12px;
            color: #9599a5;
            line-height: 23px;
          }
        }

        .tool-btn {
          margin-left: 5px;
        }
      }

      &.is-error {
        background-color: rgba(#f62733, 0.12);
      }

      &:hover {
        border-color: #409eff;
        .update-user-info {
          display: none;
        }
        .tool-icon {
          display: block;
          opacity: 1 !important;
        }
        .tool-btn {
          opacity: 1;
        }
        .field-content-btn {
          opacity: 1;
        }
      }
    }
  }
}
</style>
